import { render, staticRenderFns } from "./Detection.vue?vue&type=template&id=7c70ad88&scoped=true&"
import script from "./Detection.vue?vue&type=script&lang=js&"
export * from "./Detection.vue?vue&type=script&lang=js&"
import style0 from "./Detection.vue?vue&type=style&index=0&id=7c70ad88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70ad88",
  null
  
)

export default component.exports